// // components/ViewRoutes/ViewRoutesList.jsx
// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import { 
//   getViewRoutes, 
//   deactivateViewRoute,
//   getViewRouteStats 
// } from '../../Services/Operations/ProductAPI';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/CustomerManage.css';

// const formatDateDMY = (dateString) => {
//   if (!dateString) return 'N/A';
//   const date = new Date(dateString);
//   const day = String(date.getDate()).padStart(2, '0');
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const year = date.getFullYear();
//   return `${day}.${month}.${year}`;
// };

// const formatDateTime = (dateString) => {
//   if (!dateString) return 'N/A';
//   const date = new Date(dateString);
//   const day = String(date.getDate()).padStart(2, '0');
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const year = date.getFullYear();
//   const hours = String(date.getHours()).padStart(2, '0');
//   const minutes = String(date.getMinutes()).padStart(2, '0');
//   return `${day}.${month}.${year} ${hours}:${minutes}`;
// };

// // Skeleton Components for Loading State
// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>#</th>
//           <th>Route Number</th>
//           <th>Route Name</th>
//           <th>Local Name</th>
//           <th>Origin</th>
//           <th>Destination</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const ViewRoutesList = () => {
//   const { token } = useSelector((state) => state.user);
//   const [viewRoutes, setViewRoutes] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searching, setSearching] = useState(false);
//   const [stats, setStats] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [error, setError] = useState(null);
//   const [viewingRoute, setViewingRoute] = useState(null);
  
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalRoutes, setTotalRoutes] = useState(0);
//   const [pageSize] = useState(10);

//   const [filters, setFilters] = useState({
//     isActive: 'true',
//     sortBy: 'createdAt',
//     sortOrder: 'desc'
//   });

//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchViewRoutes();
//     }, 500);
//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm, filters.isActive, filters.sortBy, filters.sortOrder]);

//   useEffect(() => {
//     fetchStats();
//   }, []);

//   const fetchViewRoutes = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       setError(null);

//       const params = {
//         page: currentPage,
//         limit: pageSize,
//         search: searchTerm,
//         isActive: filters.isActive,
//         sortBy: filters.sortBy,
//         sortOrder: filters.sortOrder
//       };

//       const response = await getViewRoutes(token, params);

//       if (response && response.success) {
//         const transformedRoutes = response.data.map((route, index) => ({
//           id: route._id,
//           serialNo: (currentPage - 1) * pageSize + index + 1,
//           routeNumber: route.routeNumber || 'N/A',
//           routeName: route.routeName || 'N/A',
//           localRouteName: route.localRouteName || '-',
//           origin: route.origin?.city || 'N/A',
//           destination: route.destination?.city || 'N/A',
//           isRoundTrip: route.isRoundTrip || false,
//           isActive: route.isActive,
//           createdAt: route.createdAt,
//           updatedAt: route.updatedAt,
//           createdBy: route.createdBy,
//           createdByName: route.createdByName,
//           createdByEmail: route.createdByEmail,
//           createdByPhone: route.createdByPhone,
//           routeDetails: route.routeDetails,
//           intermediateStops: route.intermediateStops || [],
//           returnJourney: route.returnJourney,
//           timeSlots: route.timeSlots || [],
//           originDetails: route.origin,
//           destinationDetails: route.destination,
//           isMultiTrip: route.isMultiTrip,
//           numberOfTrips: route.numberOfTrips,
//           via: route.via || [],
//           fareMatrix: route.fareMatrix || [],
//           additionalBoardingPoints: route.additionalBoardingPoints || [],
//           additionalDroppingPoints: route.additionalDroppingPoints || [],
//           additionalNullPoints: route.additionalNullPoints || [],
//           originalRouteId: route.originalRouteId,
//           isViewOnly: route.isViewOnly,
//           __v: route.__v
//         }));

//         setViewRoutes(transformedRoutes);
//         setTotalPages(response.pagination?.pages || 1);
//         setTotalRoutes(response.pagination?.total || 0);
//       } else {
//         throw new Error(response?.message || 'Failed to fetch view routes');
//       }
//     } catch (err) {
//       setError('Failed to fetch view routes. Please try again.');
//       console.error('Error fetching view routes:', err);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const fetchStats = async () => {
//     try {
//       const response = await getViewRouteStats(token);
//       if (response && response.success) {
//         setStats(response.data);
//       }
//     } catch (err) {
//       console.error('Error fetching stats:', err);
//     }
//   };

//   const handleViewDetails = (route) => {
//     setViewingRoute(route);
//   };

//   const handleDeactivate = async (id) => {
//     if (!window.confirm('Are you sure you want to deactivate this view route?')) return;
    
//     try {
//       const response = await deactivateViewRoute(id, token);
//       if (response && response.success) {
//         alert('View route deactivated successfully!');
//         fetchViewRoutes();
//         fetchStats();
//       } else {
//         throw new Error(response?.message || 'Failed to deactivate');
//       }
//     } catch (error) {
//       console.error('Error deactivating view route:', error);
//       alert('Failed to deactivate view route');
//     }
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleFilterChange = (key, value) => {
//     setFilters({ ...filters, [key]: value });
//     setCurrentPage(1);
//   };

//   const handleRefresh = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//     setFilters({
//       isActive: 'true',
//       sortBy: 'createdAt',
//       sortOrder: 'desc'
//     });
//     fetchViewRoutes();
//     fetchStats();
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const getStatusBadge = (isActive) => {
//     return isActive ? (
//       <span className="status-badge active">Active</span>
//     ) : (
//       <span className="status-badge inactive">Inactive</span>
//     );
//   };

//   const getTripBadge = (isRoundTrip) => {
//     return isRoundTrip ? (
//       <span className="status-badge round-trip">🔄 Round Trip</span>
//     ) : (
//       <span className="status-badge one-way">➡️ One Way</span>
//     );
//   };

//   const closeViewModal = () => {
//     setViewingRoute(null);
//   };

//   const renderLocationDetails = (location, label) => {
//     if (!location) return null;
//     return (
//       <div className="detail-row">
//         <label>{label}:</label>
//         <span>
//           <div><strong>{location.city}</strong>, {location.state}</div>
//           <div style={{ fontSize: '13px', color: '#555' }}>{location.address}</div>
//           {location.terminal && <div style={{ fontSize: '13px', color: '#666' }}>Terminal: {location.terminal}</div>}
//           {location.departureTime && <div style={{ fontSize: '13px', color: '#666' }}>Departure: {location.departureTime}</div>}
//           {location.arrivalTime && <div style={{ fontSize: '13px', color: '#666' }}>Arrival: {location.arrivalTime}</div>}
//           {location.distanceFromOrigin !== undefined && (
//             <div style={{ fontSize: '13px', color: '#666' }}>Distance: {location.distanceFromOrigin} km</div>
//           )}
//           {location.coordinates && (
//             <div style={{ fontSize: '12px', color: '#888' }}>
//               Lat: {location.coordinates.lat}, Lng: {location.coordinates.lng}
//             </div>
//           )}
//           {location.timings && location.timings.length > 0 && (
//             <div style={{ fontSize: '12px', color: '#888' }}>
//               Timings: {location.timings.map((t, i) => (
//                 <span key={i}>
//                   {t.departureTime && `Depart: ${t.departureTime}`}
//                   {t.arrivalTime && ` Arrival: ${t.arrivalTime}`}
//                   {i < location.timings.length - 1 && ' | '}
//                 </span>
//               ))}
//             </div>
//           )}
//         </span>
//       </div>
//     );
//   };

//   const renderStopList = (stops, title) => {
//     if (!stops || stops.length === 0) return null;
//     return (
//       <div className="bookings-section">
//         <h4>{title}</h4>
//         <div className="bookings-table-container">
//           <table className="bookings-table">
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>City</th>
//                 <th>State</th>
//                 <th>Address</th>
//                 <th>Stop Type</th>
//                 <th>Distance</th>
//                 <th>Arrival</th>
//                 <th>Departure</th>
//                 <th>Manual Stop</th>
//               </tr>
//             </thead>
//             <tbody>
//               {stops.map((stop, idx) => (
//                 <tr key={idx}>
//                   <td>{idx + 1}</td>
//                   <td><strong>{stop.city}</strong></td>
//                   <td>{stop.state}</td>
//                   <td style={{ fontSize: '12px' }}>{stop.address}</td>
//                   <td>
//                     <span className={`status-badge ${stop.stopType || 'none'}`}>
//                       {stop.stopType || 'none'}
//                     </span>
//                   </td>
//                   <td>{stop.distanceFromOrigin || 0} km</td>
//                   <td>{stop.arrivalTime || 'N/A'}</td>
//                   <td>{stop.departureTime || 'N/A'}</td>
//                   <td>{stop.isManualStop ? 'Yes' : 'No'}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   };

//   const renderAdditionalPoints = (points, title) => {
//     if (!points || points.length === 0) return null;
//     return (
//       <div className="bookings-section">
//         <h4>{title}</h4>
//         <div className="bookings-table-container">
//           <table className="bookings-table">
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Name</th>
//                 <th>City</th>
//                 <th>State</th>
//                 <th>Address</th>
//                 <th>Landmark</th>
//                 <th>Pickup/Drop Time</th>
//               </tr>
//             </thead>
//             <tbody>
//               {points.map((point, idx) => (
//                 <tr key={idx}>
//                   <td>{idx + 1}</td>
//                   <td>{point.name || '-'}</td>
//                   <td>{point.city}</td>
//                   <td>{point.state}</td>
//                   <td style={{ fontSize: '12px' }}>{point.address}</td>
//                   <td>{point.landmark || '-'}</td>
//                   <td>{point.pickupTime || point.dropTime || point.referenceTime || 'N/A'}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   };

//   const renderFareMatrix = (fareMatrix, title) => {
//     if (!fareMatrix || fareMatrix.length === 0) return null;
//     return (
//       <div className="bookings-section">
//         <h4>{title}</h4>
//         <div className="bookings-table-container">
//           <table className="bookings-table">
//             <thead>
//               <tr>
//                 <th>From</th>
//                 <th>To</th>
//                 <th>Distance (km)</th>
//                 <th>Price</th>
//               </tr>
//             </thead>
//             <tbody>
//               {fareMatrix.map((fare, idx) => (
//                 <React.Fragment key={idx}>
//                   {fare.toCells && fare.toCells.map((cell, cellIdx) => (
//                     <tr key={`${idx}-${cellIdx}`}>
//                       <td><strong>{fare.fromName || fare.fromId}</strong></td>
//                       <td><strong>{cell.toName || cell.toId}</strong></td>
//                       <td>{cell.distanceKm || 0}</td>
//                       <td>₹{cell.price || 0}</td>
//                     </tr>
//                   ))}
//                 </React.Fragment>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   };

//   // Loading State
//   if (loading) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>
//         <div className="stats-cards">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>
//         <SkeletonTable />
//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>View Routes Management</h1>
//         <div className="header-actions">
//           <div style={{ position: 'relative' }}>
//             <input
//               type="text"
//               placeholder="Search by route name, number or local name..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//               style={{ width: "70%" }}
//             />
//             {searching && (
//               <span style={{
//                 position: 'absolute', right: '10px', top: '50%',
//                 transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//               }}>
//                 searching...
//               </span>
//             )}
//           </div>
//           <select
//             value={filters.isActive}
//             onChange={(e) => handleFilterChange('isActive', e.target.value)}
//             className="filter-select"
//             style={{ padding: '8px 12px', borderRadius: '4px', border: '1px solid #ddd' }}
//           >
//             <option value="true">Active Only</option>
//             <option value="false">Inactive Only</option>
//             <option value="">All Routes</option>
//           </select>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//         </div>
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total View Routes</h3>
//           <p>{stats?.total || 0}</p>
//           <span>All view routes</span>
//         </div>
//         <div className="stat-card">
//           <h3>Active Routes</h3>
//           <p>{stats?.totalActive || 0}</p>
//           <span>Currently active</span>
//         </div>
       
//         <div className="stat-card">
//           <h3>Unique Creators</h3>
//           <p>{stats?.createdByStats?.length || 0}</p>
//           <span>Total creators</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Route Number</th>
//               <th>Route Name</th>
//               <th>Local Name</th>
//               <th>Origin</th>
//               <th>Destination</th>
//               <th>Type</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {viewRoutes.map((route) => (
//               <tr key={route.id}>
//                 <td>{route.serialNo}</td>
//                 <td className="route-number">{route.routeNumber}</td>
//                 <td className="route-name">{route.routeName}</td>
//                 <td>{route.localRouteName}</td>
//                 <td>{route.origin}</td>
//                 <td>{route.destination}</td>
//                 <td>{getTripBadge(route.isRoundTrip)}</td>
//                 <td>{getStatusBadge(route.isActive)}</td>
//                 <td>
//                   <div className="action-buttons">
//                     <button
//                       className="action-btn view"
//                       onClick={() => handleViewDetails(route)}
//                     >
//                       View
//                     </button>
                    
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {viewRoutes.length === 0 && !loading && (
//           <div className="no-data">
//             <p>No view routes found matching your search.</p>
//           </div>
//         )}
//       </div>

//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {viewRoutes.length} of {totalRoutes} routes (Page {currentPage} of {totalPages})
//           {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//         </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>
//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }
//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>
//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//           >
//             Next
//           </button>
//         </div>
//       </div>

//       {/* View Details Modal - Full Response */}
//       {viewingRoute && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>View Route Details - Full Response</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               {/* Basic Route Information */}
//               <div className="customer-details">
//                 <h4 style={{ marginBottom: '10px', borderBottom: '2px solid #007bff', paddingBottom: '5px' }}>
//                   📋 Basic Information
//                 </h4>
                
//                 <div className="detail-row">
//                   <label>ID:</label>
//                   <span style={{ fontSize: '12px', fontFamily: 'monospace' }}>{viewingRoute.id}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Route Number:</label>
//                   <span>{viewingRoute.routeNumber}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Route Name:</label>
//                   <span><strong>{viewingRoute.routeName}</strong></span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Local Name:</label>
//                   <span>{viewingRoute.localRouteName}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Original Route ID:</label>
//                   <span>{viewingRoute.originalRouteId || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Route Type:</label>
//                   <span>{getTripBadge(viewingRoute.isRoundTrip)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Multi Trip:</label>
//                   <span>{viewingRoute.isMultiTrip ? 'Yes' : 'No'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Number of Trips:</label>
//                   <span>{viewingRoute.numberOfTrips || 1}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span>{getStatusBadge(viewingRoute.isActive)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Is View Only:</label>
//                   <span>{viewingRoute.isViewOnly ? 'Yes' : 'No'}</span>
//                 </div>
//               </div>

//               {/* Time Slots */}
//               {viewingRoute.timeSlots && viewingRoute.timeSlots.length > 0 && (
//                 <div className="bookings-section">
//                   <h4>⏰ Time Slots</h4>
//                   <div className="bookings-table-container">
//                     <table className="bookings-table">
//                       <thead>
//                         <tr>
//                           <th>Sequence</th>
//                           <th>Departure</th>
//                           <th>Arrival</th>
//                           <th>Fare Multiplier</th>
//                           <th>Active</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {viewingRoute.timeSlots.map((slot, idx) => (
//                           <tr key={idx}>
//                             <td>{slot.sequence}</td>
//                             <td>{slot.departureTime || 'N/A'}</td>
//                             <td>{slot.arrivalTime || 'N/A'}</td>
//                             <td>{slot.fareMultiplier || 1}</td>
//                             <td>{slot.isActive ? '✅' : '❌'}</td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               )}

//               {/* Origin Details */}
//               {viewingRoute.originDetails && (
//                 <div className="bookings-section">
//                   <h4>🚌 Origin Details</h4>
//                   {renderLocationDetails(viewingRoute.originDetails, 'Origin')}
//                 </div>
//               )}

//               {/* Destination Details */}
//               {viewingRoute.destinationDetails && (
//                 <div className="bookings-section">
//                   <h4>📍 Destination Details</h4>
//                   {renderLocationDetails(viewingRoute.destinationDetails, 'Destination')}
//                 </div>
//               )}

//               {/* Route Details */}
//               {viewingRoute.routeDetails && (
//                 <div className="bookings-section">
//                   <h4>📏 Route Details</h4>
//                   <div className="customer-details">
//                     <div className="detail-row">
//                       <label>Total Distance:</label>
//                       <span>{viewingRoute.routeDetails.totalDistance} km</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Estimated Duration:</label>
//                       <span>
//                         {viewingRoute.routeDetails.estimatedDuration?.hours || 0}h {' '}
//                         {viewingRoute.routeDetails.estimatedDuration?.minutes || 0}m
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Intermediate Stops */}
//               {renderStopList(viewingRoute.intermediateStops, '🛑 Intermediate Stops')}

//               {/* Additional Boarding Points */}
//               {renderAdditionalPoints(viewingRoute.additionalBoardingPoints, '⬆️ Additional Boarding Points')}

//               {/* Additional Dropping Points */}
//               {renderAdditionalPoints(viewingRoute.additionalDroppingPoints, '⬇️ Additional Dropping Points')}

//               {/* Additional Null Points */}
//               {renderAdditionalPoints(viewingRoute.additionalNullPoints, '⬛ Additional Null Points')}

//               {/* Fare Matrix */}
//               {renderFareMatrix(viewingRoute.fareMatrix, '💰 Fare Matrix')}

//               {/* Via Points */}
//               {viewingRoute.via && viewingRoute.via.length > 0 && (
//                 <div className="bookings-section">
//                   <h4>🔄 Via Points</h4>
//                   <div className="bookings-table-container">
//                     <table className="bookings-table">
//                       <thead>
//                         <tr>
//                           <th>#</th>
//                           <th>City</th>
//                           <th>State</th>
//                           <th>Sequence</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {viewingRoute.via.map((via, idx) => (
//                           <tr key={idx}>
//                             <td>{idx + 1}</td>
//                             <td>{via.city}</td>
//                             <td>{via.state}</td>
//                             <td>{via.sequence}</td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               )}

//               {/* Return Journey - Full Details */}
//               {viewingRoute.isRoundTrip && viewingRoute.returnJourney && (
//                 <div className="bookings-section" style={{ borderTop: '3px solid #007bff', marginTop: '20px', paddingTop: '20px' }}>
//                   <h3 style={{ color: '#007bff' }}>🔄 Return Journey - Full Details</h3>
                  
//                   {/* Return Journey Basic Info */}
//                   <div className="customer-details">
//                     <div className="detail-row">
//                       <label>Return Active:</label>
//                       <span>{viewingRoute.returnJourney.isActive ? 'Yes' : 'No'}</span>
//                     </div>
                  
//                   </div>

//                   {/* Return Origin */}
//                   {viewingRoute.returnJourney.origin && (
//                     <div className="bookings-section">
//                       <h4>🔙 Return Origin</h4>
//                       {renderLocationDetails(viewingRoute.returnJourney.origin, 'Return Origin')}
//                     </div>
//                   )}

//                   {/* Return Destination */}
//                   {viewingRoute.returnJourney.destination && (
//                     <div className="bookings-section">
//                       <h4>🔜 Return Destination</h4>
//                       {renderLocationDetails(viewingRoute.returnJourney.destination, 'Return Destination')}
//                     </div>
//                   )}

//                   {/* Return Route Details */}
//                   {viewingRoute.returnJourney.routeDetails && (
//                     <div className="bookings-section">
//                       <h4>📏 Return Route Details</h4>
//                       <div className="customer-details">
//                         <div className="detail-row">
//                           <label>Return Total Distance:</label>
//                           <span>{viewingRoute.returnJourney.routeDetails.totalDistance} km</span>
//                         </div>
//                         <div className="detail-row">
//                           <label>Return Estimated Duration:</label>
//                           <span>
//                             {viewingRoute.returnJourney.routeDetails.estimatedDuration?.hours || 0}h {' '}
//                             {viewingRoute.returnJourney.routeDetails.estimatedDuration?.minutes || 0}m
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   )}

//                   {/* Return Intermediate Stops */}
//                   {renderStopList(viewingRoute.returnJourney.intermediateStops, '🛑 Return Intermediate Stops')}

//                   {/* Return Additional Boarding Points */}
//                   {renderAdditionalPoints(viewingRoute.returnJourney.additionalBoardingPoints, '⬆️ Return Additional Boarding Points')}

//                   {/* Return Additional Dropping Points */}
//                   {renderAdditionalPoints(viewingRoute.returnJourney.additionalDroppingPoints, '⬇️ Return Additional Dropping Points')}

//                   {/* Return Additional Null Points */}
//                   {renderAdditionalPoints(viewingRoute.returnJourney.additionalNullPoints, '⬛ Return Additional Null Points')}

//                   {/* Return Fare Matrix */}
//                   {renderFareMatrix(viewingRoute.returnJourney.fareMatrix, '💰 Return Fare Matrix')}

//                   {/* Return Via Points */}
//                   {viewingRoute.returnJourney.via && viewingRoute.returnJourney.via.length > 0 && (
//                     <div className="bookings-section">
//                       <h4>🔄 Return Via Points</h4>
//                       <div className="bookings-table-container">
//                         <table className="bookings-table">
//                           <thead>
//                             <tr>
//                               <th>#</th>
//                               <th>City</th>
//                               <th>State</th>
//                               <th>Sequence</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {viewingRoute.returnJourney.via.map((via, idx) => (
//                               <tr key={idx}>
//                                 <td>{idx + 1}</td>
//                                 <td>{via.city}</td>
//                                 <td>{via.state}</td>
//                                 <td>{via.sequence}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {/* Created By Information */}
//               <div className="bookings-section" style={{ borderTop: '2px solid #e9ecef', marginTop: '20px', paddingTop: '20px' }}>
//                 <h4>👤 Created By Information</h4>
//                 <div className="customer-details">
//                   <div className="detail-row">
//                     <label>Created By Name:</label>
//                     <span><strong>{viewingRoute.createdByName || 'Unknown'}</strong></span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Created By Email:</label>
//                     <span>{viewingRoute.createdByEmail}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Created By Phone:</label>
//                     <span>{viewingRoute.createdByPhone || 'N/A'}</span>
//                   </div>
//                   {viewingRoute.createdBy && (
//                     <>
//                       <div className="detail-row">
//                         <label>Creator ID:</label>
//                         <span style={{ fontSize: '12px', fontFamily: 'monospace' }}>{viewingRoute.createdBy._id}</span>
//                       </div>
//                       <div className="detail-row">
//                         <label>Creator Name:</label>
//                         <span>{viewingRoute.createdBy.name}</span>
//                       </div>
//                       <div className="detail-row">
//                         <label>Creator Email:</label>
//                         <span>{viewingRoute.createdBy.email}</span>
//                       </div>
//                       <div className="detail-row">
//                         <label>Creator Phone:</label>
//                         <span>{viewingRoute.createdBy.phone || 'N/A'}</span>
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>

//               {/* Timestamps */}
//               <div className="bookings-section">
//                 <h4>⏱️ Timestamps</h4>
//                 <div className="customer-details">
//                   <div className="detail-row">
//                     <label>Created At:</label>
//                     <span>{formatDateTime(viewingRoute.createdAt)}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Updated At:</label>
//                     <span>{formatDateTime(viewingRoute.updatedAt)}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Version:</label>
//                     <span style={{ fontSize: '12px', fontFamily: 'monospace' }}>v{viewingRoute.__v || 0}</span>
//                   </div>
//                 </div>
//               </div>

//               {/* Full JSON Response - Collapsible */}
//               <div className="bookings-section" style={{ borderTop: '2px solid #e9ecef', marginTop: '20px', paddingTop: '20px' }}>
//                 <h4>📄 Full JSON Response</h4>
//                 <details style={{ marginTop: '10px' }}>
//                   <summary style={{ cursor: 'pointer', color: '#007bff', fontWeight: '500' }}>
//                     Click to expand full response
//                   </summary>
//                   <pre style={{
//                     background: '#f8f9fa',
//                     padding: '15px',
//                     borderRadius: '6px',
//                     overflow: 'auto',
//                     maxHeight: '400px',
//                     fontSize: '12px',
//                     border: '1px solid #e9ecef',
//                     marginTop: '10px'
//                   }}>
//                     {JSON.stringify(viewingRoute, null, 2)}
//                   </pre>
//                 </details>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
              
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ViewRoutesList;

// components/ViewRoutes/ViewRoutesList.jsx
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  getViewRoutes,
  deactivateViewRoute,
  getViewRouteStats
} from '../../Services/Operations/ProductAPI';
import '../../Styles/ManagementPages.css';
import '../../Styles/CustomerManage.css';
import '../../Styles/PrimaryRouteManage.css';   // modern prm- design

/* ============================================================
 * HELPERS — unchanged
 * ============================================================ */
const formatDateDMY = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};

const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day}.${month}.${year} ${hours}:${minutes}`;
};

const fmtTime = (time) => {
  if (!time || !String(time).includes(':')) return time || '--:--';
  const [h, m] = String(time).split(':').map(Number);
  if (isNaN(h) || isNaN(m)) return time;
  return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${h >= 12 ? 'PM' : 'AM'}`;
};

/* ============================================================
 * MODERN UI PRIMITIVES (mirror PrimaryRouteManage.css)
 * ============================================================ */
const ICON_PATHS = {
  route: 'M5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M19 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M7 17h7a3 3 0 0 0 0-6h-4a3 3 0 0 1 0-6h7',
  check: 'M22 11.1V12a10 10 0 1 1-5.9-9.1 M22 4 12 14l-3-3',
  calendar: 'M8 2v4 M16 2v4 M3 10h18 M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
  pin: 'M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0z M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 6v6l4 2',
  stop: 'M12 3v18 M5 6h11l3 3-3 3H5z',
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M21 21l-4.3-4.3',
  eye: 'M2 12s4-8 10-8 10 8 10 8-4 8-10 8S2 12 2 12z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  trash: 'M3 6h18 M8 6V4h8v2 M6 6l1 14h10l1-14 M10 11v6 M14 11v6',
  grid: 'M3 3h7v7H3z M14 3h7v7h-7z M14 14h7v7h-7z M3 14h7v7H3z',
  list: 'M8 6h13 M8 12h13 M8 18h13 M3 6h.01 M3 12h.01 M3 18h.01',
  tag: 'M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z M7.5 7.5h.01',
  plus: 'M12 5v14 M5 12h14',
  map: 'M1 6l7-3 8 3 7-3v15l-7 3-8-3-7 3z M8 3v15 M16 6v15',
  bus: 'M5 3h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z M3 11h18 M7 21v-3 M17 21v-3 M7 15h.01 M17 15h.01',
  edit: 'M12 20h9 M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z',
  info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 16v-4 M12 8h.01',
  refresh: 'M23 4v6h-6 M1 20v-6h6 M3.5 9a9 9 0 0 1 14.9-3.4L23 10 M1 14l4.6 4.4A9 9 0 0 0 20.5 15',
  x: 'M18 6 6 18 M6 6l12 12',
  users: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M23 21v-2a4 4 0 0 0-3-3.9 M16 3.1a4 4 0 0 1 0 7.8'
};

const Icon = ({ name, size = 18 }) => (
  <svg className="prm-ico" viewBox="0 0 24 24" width={size} height={size} fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d={ICON_PATHS[name]} />
  </svg>
);

const BusSvg = ({ size = 34 }) => (
  <svg viewBox="0 0 64 34" width={size} height={(size * 34) / 64} aria-hidden="true">
    <rect x="2" y="3" width="58" height="23" rx="7" fill="#f59e0b" />
    <rect x="2" y="19" width="58" height="4" fill="#d97706" />
    <rect x="8" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
    <rect x="19" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
    <rect x="30" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
    <path d="M43 8h10a4 4 0 0 1 4 4v4H43z" fill="#0b1f44" />
    <rect x="57" y="20" width="4" height="3" rx="1" fill="#fff7d6" />
    <circle cx="17" cy="27" r="5.5" fill="#0b1f44" /><circle cx="17" cy="27" r="2.2" fill="#cbd5e1" />
    <circle cx="46" cy="27" r="5.5" fill="#0b1f44" /><circle cx="46" cy="27" r="2.2" fill="#cbd5e1" />
  </svg>
);

const useCountUp = (target, duration = 900) => {
  const [value, setValue] = useState(0);
  useEffect(() => {
    let raf, start;
    const step = (t) => {
      if (!start) start = t;
      const p = Math.min((t - start) / duration, 1);
      setValue(Math.round(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);
  return value;
};

const StatCard = ({ icon, label, value, hint, tone, delay = 0 }) => {
  const shown = useCountUp(value);
  return (
    <div className={`prm-stat tone-${tone}`} style={{ animationDelay: `${delay}ms` }}>
      <div className="prm-stat-icon"><Icon name={icon} size={24} /></div>
      <div className="prm-stat-body">
        <div className="prm-stat-label">{label}</div>
        <div className="prm-stat-value">{shown}</div>
        <div className="prm-stat-hint">{hint}</div>
      </div>
    </div>
  );
};

/* ============================================================
 * MAIN COMPONENT
 * ============================================================ */
const ViewRoutesList = () => {
  const { token } = useSelector((state) => state.user);
  const [viewRoutes, setViewRoutes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searching, setSearching] = useState(false);
  const [stats, setStats] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [error, setError] = useState(null);
  const [viewingRoute, setViewingRoute] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRoutes, setTotalRoutes] = useState(0);
  const [pageSize] = useState(10);

  const [filters, setFilters] = useState({
    isActive: 'true',
    sortBy: 'createdAt',
    sortOrder: 'desc'
  });

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchViewRoutes();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [currentPage, searchTerm, filters.isActive, filters.sortBy, filters.sortOrder]);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchViewRoutes = async () => {
    try {
      setSearching(true);
      setLoading(true);
      setError(null);

      const params = {
        page: currentPage,
        limit: pageSize,
        search: searchTerm,
        isActive: filters.isActive,
        sortBy: filters.sortBy,
        sortOrder: filters.sortOrder
      };

      const response = await getViewRoutes(token, params);

      if (response && response.success) {
        const transformedRoutes = response.data.map((route, index) => ({
          id: route._id,
          serialNo: (currentPage - 1) * pageSize + index + 1,
          routeNumber: route.routeNumber || 'N/A',
          routeName: route.routeName || 'N/A',
          localRouteName: route.localRouteName || '-',
          origin: route.origin?.city || 'N/A',
          destination: route.destination?.city || 'N/A',
          isRoundTrip: route.isRoundTrip || false,
          isActive: route.isActive,
          createdAt: route.createdAt,
          updatedAt: route.updatedAt,
          createdBy: route.createdBy,
          createdByName: route.createdByName,
          createdByEmail: route.createdByEmail,
          createdByPhone: route.createdByPhone,
          routeDetails: route.routeDetails,
          intermediateStops: route.intermediateStops || [],
          returnJourney: route.returnJourney,
          timeSlots: route.timeSlots || [],
          originDetails: route.origin,
          destinationDetails: route.destination,
          isMultiTrip: route.isMultiTrip,
          numberOfTrips: route.numberOfTrips,
          via: route.via || [],
          fareMatrix: route.fareMatrix || [],
          additionalBoardingPoints: route.additionalBoardingPoints || [],
          additionalDroppingPoints: route.additionalDroppingPoints || [],
          additionalNullPoints: route.additionalNullPoints || [],
          originalRouteId: route.originalRouteId,
          isViewOnly: route.isViewOnly,
          __v: route.__v
        }));

        setViewRoutes(transformedRoutes);
        setTotalPages(response.pagination?.pages || 1);
        setTotalRoutes(response.pagination?.total || 0);
      } else {
        throw new Error(response?.message || 'Failed to fetch view routes');
      }
    } catch (err) {
      setError('Failed to fetch view routes. Please try again.');
      console.error('Error fetching view routes:', err);
    } finally {
      setLoading(false);
      setSearching(false);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await getViewRouteStats(token);
      if (response && response.success) {
        setStats(response.data);
      }
    } catch (err) {
      console.error('Error fetching stats:', err);
    }
  };

  const handleViewDetails = (route) => setViewingRoute(route);

  const handleDeactivate = async (id) => {
    if (!window.confirm('Are you sure you want to deactivate this view route?')) return;

    try {
      const response = await deactivateViewRoute(id, token);
      if (response && response.success) {
        alert('View route deactivated successfully!');
        fetchViewRoutes();
        fetchStats();
      } else {
        throw new Error(response?.message || 'Failed to deactivate');
      }
    } catch (error) {
      console.error('Error deactivating view route:', error);
      alert('Failed to deactivate view route');
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
    setCurrentPage(1);
  };

  const handleRefresh = () => {
    setSearchTerm('');
    setCurrentPage(1);
    setFilters({ isActive: 'true', sortBy: 'createdAt', sortOrder: 'desc' });
    fetchViewRoutes();
    fetchStats();
  };

  const closeViewModal = () => setViewingRoute(null);

  /* ---------- Location / stop / point / matrix renderers ---------- */
  const renderLocationDetails = (location) => {
    if (!location) return null;
    return (
      <div className="prm-info-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}>
        <div className="prm-info">
          <div className="l">City</div>
          <div className="v">{location.city}</div>
        </div>
        <div className="prm-info">
          <div className="l">State</div>
          <div className="v">{location.state || '—'}</div>
        </div>
        {location.terminal && (
          <div className="prm-info">
            <div className="l">Terminal</div>
            <div className="v">{location.terminal}</div>
          </div>
        )}
        {location.departureTime && (
          <div className="prm-info">
            <div className="l">Departure</div>
            <div className="v">{fmtTime(location.departureTime)}</div>
          </div>
        )}
        {location.arrivalTime && (
          <div className="prm-info">
            <div className="l">Arrival</div>
            <div className="v">{fmtTime(location.arrivalTime)}</div>
          </div>
        )}
        {location.distanceFromOrigin !== undefined && (
          <div className="prm-info">
            <div className="l">Distance</div>
            <div className="v">{location.distanceFromOrigin} km</div>
          </div>
        )}
        {location.address && (
          <div className="prm-info" style={{ gridColumn: '1 / -1' }}>
            <div className="l">Address</div>
            <div className="v" style={{ fontWeight: 600 }}>{location.address}</div>
          </div>
        )}
        {location.timings && location.timings.length > 0 && (
          <div className="prm-info" style={{ gridColumn: '1 / -1' }}>
            <div className="l">Timings</div>
            <div className="v" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 4 }}>
              {location.timings.map((t, i) => (
                <span key={i} style={{ fontSize: 13, fontWeight: 600 }}>
                  Trip {t.timeSlotSequence || i + 1}: {t.departureTime && `Dep ${fmtTime(t.departureTime)}`}{t.arrivalTime && ` · Arr ${fmtTime(t.arrivalTime)}`}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderStopList = (stops, title) => {
    if (!stops || stops.length === 0) return null;
    return (
      <>
        <div className="prm-section-title">{title}</div>
        <div className="prm-table-wrap" style={{ marginBottom: 22 }}>
          <table className="prm-table">
            <thead>
              <tr>
                <th>#</th><th>City</th><th>State</th><th>Stop Type</th>
                <th>Distance</th><th>Arrival</th><th>Departure</th><th>Manual</th>
              </tr>
            </thead>
            <tbody>
              {stops.map((stop, idx) => (
                <tr key={idx}>
                  <td><b style={{ color: 'var(--muted)' }}>{idx + 1}</b></td>
                  <td><div className="name">{stop.city}</div><div className="sub">{stop.address}</div></td>
                  <td>{stop.state}</td>
                  <td><span className="prm-tag navy">{stop.stopType || 'none'}</span></td>
                  <td>{stop.distanceFromOrigin || 0} km</td>
                  <td>{fmtTime(stop.arrivalTime)}</td>
                  <td>{fmtTime(stop.departureTime)}</td>
                  <td>{stop.isManualStop ? 'Yes' : 'No'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  const renderAdditionalPoints = (points, title) => {
    if (!points || points.length === 0) return null;
    return (
      <>
        <div className="prm-section-title">{title}</div>
        <div className="prm-table-wrap" style={{ marginBottom: 22 }}>
          <table className="prm-table">
            <thead>
              <tr>
                <th>#</th><th>Name</th><th>City</th><th>State</th><th>Landmark</th><th>Time</th>
              </tr>
            </thead>
            <tbody>
              {points.map((p, idx) => (
                <tr key={idx}>
                  <td><b style={{ color: 'var(--muted)' }}>{idx + 1}</b></td>
                  <td>{p.name || '-'}</td>
                  <td>{p.city}</td>
                  <td>{p.state}</td>
                  <td>{p.landmark || '-'}</td>
                  <td>{fmtTime(p.pickupTime || p.dropTime || p.referenceTime)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  const renderFareMatrix = (fareMatrix, title) => {
    if (!fareMatrix || fareMatrix.length === 0) return null;
    return (
      <>
        <div className="prm-section-title">{title}</div>
        <div className="prm-table-wrap" style={{ marginBottom: 22 }}>
          <table className="prm-table">
            <thead>
              <tr><th>From</th><th>To</th><th>Distance (km)</th><th>Price</th></tr>
            </thead>
            <tbody>
              {fareMatrix.map((fare, idx) => (
                <React.Fragment key={idx}>
                  {fare.toCells && fare.toCells.map((cell, cellIdx) => (
                    <tr key={`${idx}-${cellIdx}`}>
                      <td><b>{fare.fromName || fare.fromId}</b></td>
                      <td><b>{cell.toName || cell.toId}</b></td>
                      <td>{cell.distanceKm || 0}</td>
                      <td><span className="prm-tag teal">₹{cell.price || 0}</span></td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  /* ============================================================
   * LOADING SKELETON
   * ============================================================ */
  if (loading) {
    return (
      <div className="prm-page">
        <div className="prm-hero">
          <div className="prm-hero-text">
            <span className="prm-eyebrow"><Icon name="bus" size={13} /> View Routes</span>
            <h1>View Routes Management</h1>
            <p>Loading routes…</p>
          </div>
        </div>
        <div style={{ height: 24 }} />
        <div className="prm-grid">
          {[0, 1, 2].map(i => (
            <div className="prm-skel" key={i}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  /* ============================================================
   * MAIN RETURN
   * ============================================================ */
  return (
    <div className="prm-page">
      {/* ============================== HERO ============================== */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true">
          <span className="prm-hero-roadbus"><BusSvg size={46} /></span>
        </div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="eye" size={13} /> Read-only Snapshot</span>
          <h1>View Routes Management</h1>
          <p>Browse route snapshots created by executives — complete with stops, timings and fare matrix.</p>
        </div>
        <div className="prm-hero-actions">
          <div className="prm-search">
            <Icon name="search" size={17} />
            <input
              type="text"
              placeholder="Search by route name, number or local name…"
              value={searchTerm}
              onChange={handleSearchChange}
            />
            {searchTerm && <button className="prm-search-clear" onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>×</button>}
          </div>
          <button className="prm-btn ghost" style={{ padding: '13px 16px' }} onClick={handleRefresh} title="Refresh">
            <Icon name="refresh" size={16} />
          </button>
        </div>
      </div>

      {error && (
        <div className="prm-callout rose" style={{ marginTop: 20, background: '#ffe4ea', borderColor: '#e11d48', color: '#be123c' }}>
          <Icon name="info" size={18} />
          <div>
            <strong>Error</strong>
            <span>{error}</span>
          </div>
        </div>
      )}

      {/* ============================== STATS ============================== */}
      <div className="prm-stats">
        <StatCard icon="route" tone="indigo" label="Total View Routes" value={stats?.total || 0} hint="All view routes" delay={80} />
        <StatCard icon="check" tone="green" label="Active Routes" value={stats?.totalActive || 0} hint="Currently active" delay={160} />
        <StatCard icon="users" tone="amber" label="Unique Creators" value={stats?.createdByStats?.length || 0} hint="Total creators" delay={240} />
        <StatCard icon="list" tone="cyan" label="This Page" value={viewRoutes.length} hint="Routes shown" delay={320} />
      </div>

      {/* ============================== TOOLBAR ============================== */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <div className="prm-chips">
            <button className={`prm-chip ${filters.isActive === 'true' ? 'active' : ''}`} onClick={() => handleFilterChange('isActive', 'true')}>
              <Icon name="check" size={13} /> Active
            </button>
            <button className={`prm-chip ${filters.isActive === 'false' ? 'active' : ''}`} onClick={() => handleFilterChange('isActive', 'false')}>
              <Icon name="x" size={13} /> Inactive
            </button>
            <button className={`prm-chip ${filters.isActive === '' ? 'active' : ''}`} onClick={() => handleFilterChange('isActive', '')}>
              <Icon name="list" size={13} /> All
            </button>
          </div>
        </div>
        <div className="prm-toolbar-right">
          <span className="prm-result-count">
            Showing <b>{viewRoutes.length}</b> of {totalRoutes}
            {searching && <span style={{ marginLeft: 8, color: 'var(--amber-deep)' }}>· searching…</span>}
          </span>
        </div>
      </div>

      {/* ============================== TABLE ============================== */}
      {viewRoutes.length === 0 ? (
        <div className="prm-empty">
          <div className="icon"><Icon name={searchTerm ? 'search' : 'route'} size={44} /></div>
          <h3>{searchTerm ? 'No routes match your search' : 'No view routes found'}</h3>
          <p>{searchTerm ? 'Try a different search term or clear filters.' : 'There are currently no view routes to display.'}</p>
          {searchTerm && (
            <button className="prm-btn ghost" onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>Clear search</button>
          )}
        </div>
      ) : (
        <div className="prm-table-wrap">
          <table className="prm-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Route</th>
                <th>Local Name</th>
                <th>Origin → Destination</th>
                <th>Type</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {viewRoutes.map((route, i) => (
                <tr key={route.id} style={{ animationDelay: `${i * 60}ms` }}>
                  <td><b style={{ color: 'var(--muted)' }}>{route.serialNo}</b></td>
                  <td>
                    <div className="name">{route.routeName}</div>
                    <div className="sub"><span className="prm-tag navy">#{route.routeNumber}</span></div>
                  </td>
                  <td>{route.localRouteName}</td>
                  <td>
                    <div className="name">{route.origin}</div>
                    <div className="sub">→ {route.destination}</div>
                  </td>
                  <td>
                    <span className="prm-tag" style={{
                      background: route.isRoundTrip ? 'var(--amber-soft)' : 'var(--blue-soft)',
                      color: route.isRoundTrip ? 'var(--amber-deep)' : 'var(--navy-800)'
                    }}>
                      {route.isRoundTrip ? '🔄 Round Trip' : '➡️ One Way'}
                    </span>
                  </td>
                  <td>
                    <span className={`prm-status ${route.isActive ? 'active' : 'inactive'}`}>
                      {route.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>
                    <div className="prm-row-actions">
                      <button className="prm-btn view icon-only" onClick={() => handleViewDetails(route)} title="View" aria-label="View"><Icon name="eye" size={15} /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ============================== PAGINATION ============================== */}
      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 22, flexWrap: 'wrap' }}>
          <button className="prm-btn ghost" onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1}>
            Previous
          </button>
          <span style={{ padding: '11px 16px', fontWeight: 700, color: 'var(--navy-800)' }}>
            Page {currentPage} of {totalPages}
          </span>
          <button className="prm-btn ghost" onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages}>
            Next
          </button>
        </div>
      )}

      {/* ============================================================
       * VIEW ROUTE DETAILS MODAL — Modern redesign
       * ============================================================ */}
      {viewingRoute && (
        <div className="prm-overlay" onClick={closeViewModal}>
          <div className="prm-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 900 }}>
            <div className="prm-modal-head">
              <h3>{viewingRoute.routeName}</h3>
              <p>
                <Icon name="tag" size={14} /> #{viewingRoute.routeNumber} · {viewingRoute.localRouteName} · {viewingRoute.isRoundTrip ? 'Round Trip' : 'One Way'}
              </p>
              <button className="prm-modal-close" onClick={closeViewModal}>×</button>
            </div>

            <div className="prm-modal-body">
              {/* ---------- BASIC INFO ---------- */}
              <div className="prm-info-grid">
                <div className="prm-info">
                  <div className="l">Distance</div>
                  <div className="v"><Icon name="pin" size={17} /> {viewingRoute.routeDetails?.totalDistance || 0} km</div>
                </div>
                <div className="prm-info">
                  <div className="l">Duration</div>
                  <div className="v"><Icon name="clock" size={17} /> {viewingRoute.routeDetails?.estimatedDuration?.hours || 0}h {viewingRoute.routeDetails?.estimatedDuration?.minutes || 0}m</div>
                </div>
                <div className="prm-info">
                  <div className="l">Stops</div>
                  <div className="v"><Icon name="stop" size={17} /> {viewingRoute.intermediateStops?.length || 0}</div>
                </div>
                <div className="prm-info">
                  <div className="l">Status</div>
                  <div className="v">
                    <span className={`prm-status ${viewingRoute.isActive ? 'active' : 'inactive'}`}>
                      {viewingRoute.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                </div>
                <div className="prm-info">
                  <div className="l">Multi-Trip</div>
                  <div className="v">{viewingRoute.isMultiTrip ? `Yes · ${viewingRoute.numberOfTrips || 1} trips` : 'No'}</div>
                </div>
                <div className="prm-info">
                  <div className="l">View-Only</div>
                  <div className="v">{viewingRoute.isViewOnly ? 'Yes' : 'No'}</div>
                </div>
              </div>

              {/* ---------- IDS ---------- */}
              <div className="prm-section-title">Identification</div>
              <div className="prm-info-grid" style={{ marginBottom: 22 }}>
                <div className="prm-info" style={{ gridColumn: '1 / -1' }}>
                  <div className="l">Route ID</div>
                  <div className="v" style={{ fontFamily: 'monospace', fontSize: 13 }}>{viewingRoute.id}</div>
                </div>
                {viewingRoute.originalRouteId && (
                  <div className="prm-info" style={{ gridColumn: '1 / -1' }}>
                    <div className="l">Original Route ID</div>
                    <div className="v" style={{ fontFamily: 'monospace', fontSize: 13 }}>{viewingRoute.originalRouteId}</div>
                  </div>
                )}
              </div>

              {/* ---------- TIMESLOTS ---------- */}
              {viewingRoute.timeSlots && viewingRoute.timeSlots.length > 0 && (
                <>
                  <div className="prm-section-title">Time Slots</div>
                  <div className="prm-table-wrap" style={{ marginBottom: 22 }}>
                    <table className="prm-table">
                      <thead>
                        <tr><th>Sequence</th><th>Departure</th><th>Arrival</th><th>Fare Multiplier</th><th>Active</th></tr>
                      </thead>
                      <tbody>
                        {viewingRoute.timeSlots.map((slot, idx) => (
                          <tr key={idx}>
                            <td><b>{slot.sequence}</b></td>
                            <td>{fmtTime(slot.departureTime)}</td>
                            <td>{fmtTime(slot.arrivalTime)}</td>
                            <td>{slot.fareMultiplier || 1}</td>
                            <td>{slot.isActive ? '✅' : '❌'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}

              {/* ---------- JOURNEY TIMELINE ---------- */}
              <div className="prm-section-title">Journey Timeline</div>
              <div className="prm-timeline">
                {/* Origin */}
                {viewingRoute.originDetails && (
                  <div className="prm-tl-item origin">
                    <div className="prm-tl-city">
                      {viewingRoute.originDetails.city}
                      <small>{viewingRoute.originDetails.terminal}</small>
                    </div>
                    {viewingRoute.originDetails.timings && viewingRoute.originDetails.timings.length > 0 ? (
                      <div className="prm-tl-time">
                        {viewingRoute.originDetails.timings.map((t, i) => (
                          <div key={i}><b>Trip {t.timeSlotSequence || i + 1}:</b> Dep {fmtTime(t.departureTime)}</div>
                        ))}
                      </div>
                    ) : (
                      <div className="prm-tl-time">Departs <b>{fmtTime(viewingRoute.originDetails.departureTime)}</b></div>
                    )}
                    {viewingRoute.originDetails.address && <div className="prm-tl-time">{viewingRoute.originDetails.address}</div>}
                  </div>
                )}

                {/* Intermediate Stops */}
                {viewingRoute.intermediateStops && viewingRoute.intermediateStops.map((s, i) => (
                  <div key={i} className="prm-tl-item stop" style={{ animationDelay: `${(i + 1) * 80}ms` }}>
                    <div className="prm-tl-city">
                      {s.sequence || i + 1}. {s.city}
                      <small>{s.distanceFromOrigin?.toFixed?.(1) || s.distanceFromOrigin || 0} km from origin</small>
                    </div>
                    {s.timings && s.timings.length > 0 ? (
                      <div className="prm-tl-time">
                        {s.timings.map((t, k) => (
                          <div key={k}><b>Trip {t.timeSlotSequence || k + 1}:</b> Arr {fmtTime(t.arrivalTime)} · Dep {fmtTime(t.departureTime)}</div>
                        ))}
                      </div>
                    ) : (
                      <div className="prm-tl-time">Arr <b>{fmtTime(s.arrivalTime)}</b> · Dep <b>{fmtTime(s.departureTime)}</b></div>
                    )}
                    {s.terminal && <div className="prm-tl-time">Terminal: {s.terminal}</div>}
                  </div>
                ))}

                {/* Destination */}
                {viewingRoute.destinationDetails && (
                  <div className="prm-tl-item dest" style={{ animationDelay: `${((viewingRoute.intermediateStops?.length || 0) + 1) * 80}ms` }}>
                    <div className="prm-tl-city">
                      {viewingRoute.destinationDetails.city}
                      <small>{viewingRoute.destinationDetails.terminal}</small>
                    </div>
                    {viewingRoute.destinationDetails.timings && viewingRoute.destinationDetails.timings.length > 0 ? (
                      <div className="prm-tl-time">
                        {viewingRoute.destinationDetails.timings.map((t, i) => (
                          <div key={i}><b>Trip {t.timeSlotSequence || i + 1}:</b> Arr {fmtTime(t.arrivalTime)}</div>
                        ))}
                      </div>
                    ) : (
                      <div className="prm-tl-time">Arrives <b>{fmtTime(viewingRoute.destinationDetails.arrivalTime)}</b></div>
                    )}
                    {viewingRoute.destinationDetails.address && <div className="prm-tl-time">{viewingRoute.destinationDetails.address}</div>}
                  </div>
                )}
              </div>

              {/* ---------- ROUTE DETAILS ---------- */}
              {viewingRoute.routeDetails && (
                <>
                  <div className="prm-section-title">Route Details</div>
                  <div className="prm-info-grid" style={{ marginBottom: 22 }}>
                    <div className="prm-info">
                      <div className="l">Total Distance</div>
                      <div className="v">{viewingRoute.routeDetails.totalDistance} km</div>
                    </div>
                    <div className="prm-info">
                      <div className="l">Estimated Duration</div>
                      <div className="v">{viewingRoute.routeDetails.estimatedDuration?.hours || 0}h {viewingRoute.routeDetails.estimatedDuration?.minutes || 0}m</div>
                    </div>
                  </div>
                </>
              )}

              {/* ---------- TABLES ---------- */}
              {renderStopList(viewingRoute.intermediateStops, '🛑 Intermediate Stops')}
              {renderAdditionalPoints(viewingRoute.additionalBoardingPoints, '⬆️ Additional Boarding Points')}
              {renderAdditionalPoints(viewingRoute.additionalDroppingPoints, '⬇️ Additional Dropping Points')}
              {renderAdditionalPoints(viewingRoute.additionalNullPoints, '⬛ Additional Null Points')}
              {renderFareMatrix(viewingRoute.fareMatrix, '💰 Fare Matrix')}

              {/* ---------- VIA ---------- */}
              {viewingRoute.via && viewingRoute.via.length > 0 && (
                <>
                  <div className="prm-section-title">Via Points</div>
                  <div className="prm-table-wrap" style={{ marginBottom: 22 }}>
                    <table className="prm-table">
                      <thead><tr><th>#</th><th>City</th><th>State</th><th>Sequence</th></tr></thead>
                      <tbody>
                        {viewingRoute.via.map((v, idx) => (
                          <tr key={idx}>
                            <td><b style={{ color: 'var(--muted)' }}>{idx + 1}</b></td>
                            <td>{v.city}</td><td>{v.state}</td><td>{v.sequence}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}

              {/* ---------- RETURN JOURNEY ---------- */}
              {viewingRoute.isRoundTrip && viewingRoute.returnJourney && (
                <>
                  <div className="prm-section-title" style={{ marginTop: 30 }}>🔄 Return Journey</div>
                  <div className="prm-info-grid" style={{ marginBottom: 22 }}>
                    <div className="prm-info">
                      <div className="l">Return Active</div>
                      <div className="v">{viewingRoute.returnJourney.isActive ? 'Yes' : 'No'}</div>
                    </div>
                    {viewingRoute.returnJourney.routeDetails && (
                      <>
                        <div className="prm-info">
                          <div className="l">Return Distance</div>
                          <div className="v">{viewingRoute.returnJourney.routeDetails.totalDistance} km</div>
                        </div>
                        <div className="prm-info">
                          <div className="l">Return Duration</div>
                          <div className="v">{viewingRoute.returnJourney.routeDetails.estimatedDuration?.hours || 0}h {viewingRoute.returnJourney.routeDetails.estimatedDuration?.minutes || 0}m</div>
                        </div>
                      </>
                    )}
                  </div>

                  {viewingRoute.returnJourney.origin && (
                    <>
                      <div className="prm-section-title">🔙 Return Origin</div>
                      {renderLocationDetails(viewingRoute.returnJourney.origin)}
                    </>
                  )}
                  {viewingRoute.returnJourney.destination && (
                    <>
                      <div className="prm-section-title" style={{ marginTop: 22 }}>🔜 Return Destination</div>
                      {renderLocationDetails(viewingRoute.returnJourney.destination)}
                    </>
                  )}
                  {renderStopList(viewingRoute.returnJourney.intermediateStops, '🛑 Return Intermediate Stops')}
                  {renderAdditionalPoints(viewingRoute.returnJourney.additionalBoardingPoints, '⬆️ Return Boarding Points')}
                  {renderAdditionalPoints(viewingRoute.returnJourney.additionalDroppingPoints, '⬇️ Return Dropping Points')}
                  {renderAdditionalPoints(viewingRoute.returnJourney.additionalNullPoints, '⬛ Return Null Points')}
                  {renderFareMatrix(viewingRoute.returnJourney.fareMatrix, '💰 Return Fare Matrix')}

                  {viewingRoute.returnJourney.via && viewingRoute.returnJourney.via.length > 0 && (
                    <>
                      <div className="prm-section-title">Return Via Points</div>
                      <div className="prm-table-wrap" style={{ marginBottom: 22 }}>
                        <table className="prm-table">
                          <thead><tr><th>#</th><th>City</th><th>State</th><th>Sequence</th></tr></thead>
                          <tbody>
                            {viewingRoute.returnJourney.via.map((v, idx) => (
                              <tr key={idx}>
                                <td><b style={{ color: 'var(--muted)' }}>{idx + 1}</b></td>
                                <td>{v.city}</td><td>{v.state}</td><td>{v.sequence}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </>
              )}

              {/* ---------- CREATED BY ---------- */}
              <div className="prm-section-title" style={{ marginTop: 30 }}>👤 Created By</div>
              <div className="prm-info-grid" style={{ marginBottom: 22 }}>
                <div className="prm-info">
                  <div className="l">Name</div>
                  <div className="v">{viewingRoute.createdByName || 'Unknown'}</div>
                </div>
                <div className="prm-info">
                  <div className="l">Email</div>
                  <div className="v" style={{ fontSize: 13, fontWeight: 600 }}>{viewingRoute.createdByEmail || 'N/A'}</div>
                </div>
                <div className="prm-info">
                  <div className="l">Phone</div>
                  <div className="v">{viewingRoute.createdByPhone || 'N/A'}</div>
                </div>
                {viewingRoute.createdBy && (
                  <div className="prm-info" style={{ gridColumn: '1 / -1' }}>
                    <div className="l">Creator ID</div>
                    <div className="v" style={{ fontFamily: 'monospace', fontSize: 13 }}>{viewingRoute.createdBy._id}</div>
                  </div>
                )}
              </div>

              {/* ---------- TIMESTAMPS ---------- */}
              <div className="prm-section-title">Timestamps</div>
              <div className="prm-info-grid" style={{ marginBottom: 22 }}>
                <div className="prm-info">
                  <div className="l">Created At</div>
                  <div className="v">{formatDateTime(viewingRoute.createdAt)}</div>
                </div>
                <div className="prm-info">
                  <div className="l">Updated At</div>
                  <div className="v">{formatDateTime(viewingRoute.updatedAt)}</div>
                </div>
                <div className="prm-info">
                  <div className="l">Version</div>
                  <div className="v">v{viewingRoute.__v || 0}</div>
                </div>
              </div>

              {/* ---------- FULL JSON ---------- */}
              <details style={{ marginTop: 20, borderTop: '1px solid var(--line)', paddingTop: 20 }}>
                <summary style={{ cursor: 'pointer', color: 'var(--amber-deep)', fontWeight: 800, fontSize: 12.5, textTransform: 'uppercase', letterSpacing: '.1em' }}>
                  📄 Full JSON Response
                </summary>
                <pre style={{
                  background: '#f6f8fc',
                  padding: 15,
                  borderRadius: 12,
                  overflow: 'auto',
                  maxHeight: 400,
                  fontSize: 12,
                  border: '1px solid var(--line)',
                  marginTop: 12,
                  fontFamily: 'monospace'
                }}>
                  {JSON.stringify(viewingRoute, null, 2)}
                </pre>
              </details>
            </div>

            <div className="prm-modal-foot">
              <button className="prm-btn primary" style={{ padding: '11px 28px' }} onClick={closeViewModal}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewRoutesList;